export default {
  "content": "<path d=\"M7.5 7.414l2.793 2.793 1.414-1.414-4.5-4.5a1 1 0 00-1.414 0l-4.5 4.5 1.414 1.414L5.5 7.414V19h2V7.414zM22 7h-8v2h8V7z\" fill=\"#7B61FF\"/><path d=\"M22 12H10v2h12v-2zM22 17H10v2h12v-2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};